// extracted by mini-css-extract-plugin
var _1 = "DocFlowEditFinalDocumentFields-modulecheckbox__iNqHb";
var _2 = "DocFlowEditFinalDocumentFields-modulecheckboxIcon__fvCim";
var _3 = "DocFlowEditFinalDocumentFields-modulefield__yWZbu";
var _4 = "DocFlowEditFinalDocumentFields-moduleselect__Oo0wr";
export { _1 as "checkbox", _2 as "checkboxIcon", _3 as "field", _4 as "select" }
